import { pluralize } from "@shared/svelte/Modules/pluralize";
import { sizeAndUnitsDisplay } from "@shared/services/product";

var filter = function () {
  return function (product, opts, productTypesStore, showKegSpecificDisplay) {
    if (product == null || product == undefined) {
      return;
    }
    var res = [];
    if (!opts) {
      opts = [];
    }
    if (product.container_size) {
      const shouldSpaceDelimitSize = true;
      var size = sizeAndUnitsDisplay(product, shouldSpaceDelimitSize, showKegSpecificDisplay);
      if (product.container_units) {
        if (product.container_type) {
          if (product.container_type == "bottle" && product.material) {
            size += " " + product.material; //+ " " + product.container_type;
          }
          // note - will have to update here if we add new bottle tops types
          if (product.bottle_tops == "twist_off") {
            size += " twist off";
          }
          size += " " + product.container_type;
        }
      }
      res.push(size);
    }
    if (opts.indexOf("upc") > -1) {
      res.push(product.unit_gtin);
    }
    if (product.container_carton_size && product.container_carton_size > 1) {
      res.push(String(product.container_carton_size) + " pack");
    }
    if (product.container_type != "keg" && product.container_case_size) {
      if (product.container_type == "other") {
        res.push(String(product.container_case_size) + "/case");
      } else {
        res.push(
          String(product.container_case_size) + " " + pluralize(product.container_type) + "/case",
        );
      }
    }

    if (product.packaging_description) {
      if (productTypesStore !== undefined && productTypesStore !== null) {
        res.push(
          productTypesStore.product_packaging_descriptions_key_map[product.packaging_description]
            .name,
        );
      } else if (window.sharedContext) {
        for (const ppd of window.sharedContext.productPackagingDescriptions) {
          if (product.packaging_description === ppd.key) {
            res.push(ppd.name);
          }
        }
      }
    }

    if (product.vintage_year && !opts.indexOf("novintage") > -1) {
      res.push(`Vintage: ${product.vintage_year}`);
    }
    return res.join(" - ");
  };
};

filter.$inject = [];

tiz.filter("productContainerDetails", filter);

var filter2 = function () {
  return function (product) {
    if (product == null || product == undefined) {
      return;
    }
    var res = [];
    if (product.unit_quantity > 0) {
      if (product.container_type == "other") {
        res.push(product.unit_quantity);
      } else {
        for (const container_type of product.container_type) {
          let quantity = product.container_counts[container_type];
          if (quantity) {
            res.push(`${quantity}` + " " + pluralize(container_type, quantity));
          }
        }
      }
    }
    if (product.case_quantity > 0) {
      res.push(product.case_quantity + " " + pluralize("case", product.case_quantity));
    }
    return res.join(", ");
  };
};

tiz.filter("productContainerQuantities", filter2);

export const productContainerDetailsShort = function (product, opts) {
  if (product == null || product == undefined) {
    return;
  }
  var res = [];

  if (product.container_type != "keg" && product.container_case_size) {
    if (product.container_type == "other") {
      res.push(String(product.container_case_size) + "/case");
    } else {
      res.push(
        String(product.container_case_size) + " " + pluralize(product.container_type) + "/case",
      );
    }
  }

  if (product.container_carton_size && product.container_carton_size > 1) {
    res.push(String(product.container_carton_size) + " pack");
  }
  return res.join(" - ");
};

var filter3 = function () {
  return productContainerDetailsShort;
};

tiz.filter("productContainerDetailsShort", filter3);

var filter4 = function () {
  return function (product, opts) {
    if (product == null || product == undefined) {
      return;
    }
    var size = "";

    if (product.container_size) {
      size = sizeAndUnitsDisplay(product, true, false);

      if (product.container_carton_size) {
        size += " - " + product.container_carton_size + " pack";
      }
    }
    return size;
  };
};

tiz.filter("productContainerDetailsShorter", filter4);

export default filter;
